
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "NVHorizonTimeLine",
  components: {
  },
})
export default class NVTimeLine extends BaseVue {
 @Prop({ default: () => [] }) timelineData!:any
 @Prop({ default: "" })  ActivePoint!:string;
   mounted() {
  }
  clickEvent(item){
    this.$emit("on-change",item) 
  }
}
